module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm06_list"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("List of Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm07_intro#fig1"
    }
  }, [_vm._v("1. Liberty tree, James Pike’s powderhorn, 1776")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#fig2"
    }
  }, [_vm._v("2. "), _c('em', [_vm._v("Pat Lyon at the Forge")]), _vm._v(", oil painting by John Neagle, 1827")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#fig3"
    }
  }, [_vm._v("3. Poor Richard Illustrated, engraving, c.1796")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#fig4"
    }
  }, [_vm._v("4. General Society of Mechanics and Tradesmen of New York certificate")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#fig5"
    }
  }, [_vm._v("5. Society of Master Sailmakers certificate")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The death of Christopher Seider, broadside, 1770")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. “A New Method of Macarony Making,” engraving, 1774")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Oliver Cromwell, engraving, Nathaneal Low’s "), _c('em', [_vm._v("Almanack for 1774")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Society of Pewterers of New York, flag, 1788")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. “Gen. Daniel Shays and Col. Job Shattuck,” engraving, 1787")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. “The World Turned Upside Down,” engraving, 1783")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Thomas Paine, engraving, London, c.1792")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. “Mad Tom in a Rage,” engraving, c.1800")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Map of the Freedom Trail")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Liberty tree, engraving by Paul Revere, 1765")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. “The True-Born Sons of Liberty,” broadside, Boston, 1765")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Liberty pole, New York City, engraving by P. E. DuSimitiere, c.1770")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#fig18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. “Defence of the Liberty Pole in New York,” by Felix Darley")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2a4b590","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm06_list.vue
// module id = 75
// module chunks = 0